<template>
  <div>
    <section>
      <h1 class="title is-3 print-no-vertical" v-text="meeting.name"></h1>
      <h2 class="subtitle is-6">
        <span class="icon"><i class="fas fa-calendar-alt"></i></span
        >{{
          `${formatTime(meeting.start_date)} - ${formatTime(meeting.end_date)}`
        }}
      </h2>
    </section>
    <div class="columns mt-4">
      <div class="column is-one-quarter is-hidden-print">
        <nav class="menu">
          <ul class="menu-list">
            <li>
              <router-link
                :to="{ name: 'UserSuites', params: { id: meeting.id } }"
                exact
                >View Your Schedule</router-link
              >
            </li>
          </ul>
          <ul
            v-if="writeableSuites.length && meeting.phase_index === 2"
            class="menu-list"
          >
            <li>
              <router-link :to="{ name: 'ViewExhibitors' }"
                >Schedule an Appointment</router-link
              >
            </li>
          </ul>
          <p v-if="writeableSuites.length" class="menu-label">Manage Suites</p>
          <ul v-if="writeableSuites.length" class="menu-list">
            <li
              v-if="isSuiteWriteable(key)"
              v-for="(key, idx) in sortedSuiteKeys"
              :key="idx"
            >
              <a href="#" @click.prevent="clickEditSuite(key)">{{
                suites[key].name
              }}</a>
            </li>
          </ul>
        </nav>
      </div>
      <div class="column">
        <main class="main">
          <router-view></router-view>
        </main>
      </div>
      <modal
        title="Edit Suite"
        width="800px"
        @close="showingModal = false"
        v-if="showingModal"
      >
        <edit-suite :suite="selectedSuite" :isAdmin="false"> </edit-suite>
        <div slot="footer">
          <button
            class="button is-success"
            :class="{ 'is-loading': loading }"
            @click="saveSuite"
          >
            Save
          </button>
          <button class="button" @click="showingModal = false">Cancel</button>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
import Modal from './shared/Modal';
import EditSuite from './shared/EditSuite';
import { mapGetters } from 'vuex';
import { store } from '@/services/store';
import db from '@/services/firebase';
import dbhelpers from '@/services/dbhelpers';
import { firestoreTimestampToDate } from '@/services/utils';

export default {
  props: ['id'],

  data() {
    return {
      showingModal: false,
      loading: false,
      selectedSuite: {},
      selectedSuiteId: '',
      suites: {},
      activeSuiteKey: Object.keys(
        store.getters.user.meetings[this.id].suites
      )[0],
      meeting: {}
    };
  },
  computed: {
    ...mapGetters(['user']),
    writeableSuites() {
      let userSuites = this.user.meetings[this.id].suites;
      return Object.keys(userSuites).filter(suiteId => userSuites[suiteId]);
    },
    activeSuite() {
      return this.suites[this.activeSuiteKey];
    },
    sortedSuiteKeys() {
      return Object.keys(this.suites).sort((a, b) => {
        const suiteAName = this.suites[a].name ? this.suites[a].name : '';
        const suiteBName = this.suites[b].name ? this.suites[b].name : '';
        return suiteAName.localeCompare(suiteBName);
      });
    }
  },
  methods: {
    isSuiteWriteable(suiteId) {
      return this.writeableSuites.filter(suite => suite === suiteId).length;
    },
    clickEditSuite(suiteId) {
      this.selectedSuite = this.suites[suiteId];
      this.selectedSuiteId = suiteId;
      this.showingModal = true;
    },
    saveSuite(suiteId) {
      db.collection('meetings')
        .doc(this.id)
        .collection('suites')
        .doc(this.selectedSuiteId)
        .update({
          name: this.selectedSuite.name,
          description: this.selectedSuite.description,
          logo_path: this.selectedSuite.logo_path
        });
      this.showingModal = false;
    },
    formatTime: firestoreTimestampToDate
  },
  components: {
    Modal,
    EditSuite
  },
  firestore() {
    return {
      meeting: db.collection('meetings').doc(this.id)
    };
  },
  created() {
    dbhelpers.getUserSuiteDocs(this.id).forEach(suiteDoc => {
      suiteDoc.onSnapshot(snap => {
        this.$set(this.suites, snap.id, { ...snap.data() });
      });
    });

    dbhelpers.getAllMeetingSuites(this.id);
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/AttendeeDashboard.vue